export const staffNotificationKeys = {
  all: ['notifications', 'staff'] as const,
  list: () => [...staffNotificationKeys.all, 'list'] as const,
  unreadCount: () => [...staffNotificationKeys.all, 'unread-count'] as const,
};
